export enum ESTADO_VALID_CPU  {
   BAJO = 0, 
   ACEPTABLE = 1,
   COMPLETO = 2
}